module.exports = __webpack_public_path__ + "img/主页2.483b23d2.jpg";